export default {
    pickup: "Afhalen",
    delivery: "Bezorgen",
}
